import { useState } from 'react';
import { geographicConflicts, geographicReviewCurrent, geographicScope, geographicScopeKey, type GeographicReview } from '../../functions/src/common/geographicConflict';

export function useGeographicConfirmation(code: string, intake: any, identity = '', savedReview?: GeographicReview | null) {
    const scope = geographicScope(code, intake);
    const key = geographicScopeKey(scope);
    const stamp = `${identity}:${key}`;
    const saved = savedReview ? `${savedReview.scopeKey}:${savedReview.confirmedAt}` : '';
    const [selection, setSelection] = useState({ stamp, saved, value: null as boolean | null, invalidated: false });
    let current = selection;
    if (selection.stamp !== stamp || selection.saved !== saved) {
        current = { stamp, saved, value: null, invalidated: selection.saved === saved
            && (selection.invalidated || selection.value !== null || Boolean(saved)) };
        setSelection(current);
    }
    const confirmed = current.value ?? (!current.invalidated && geographicReviewCurrent(scope, savedReview));
    return { scope, confirmed, blocked: geographicConflicts(scope).length > 0 && !confirmed,
        confirmation: confirmed ? key : '', onConfirm: (value: boolean) => setSelection({ ...current, value }) };
}
